import { FormOption } from 'types';

export enum FilterOption {
  hour = 'HOUR_FILTER',
  filterless = 'NO_FILTER',
}

export const filterFormOptions: FormOption[] = [
  { label: 'Filtrar por hora', value: FilterOption.hour },
  { label: 'Sem filtro', value: FilterOption.filterless },
];
